import { useIsAuthenticated } from "core/hooks"
import { useQuery } from "@tanstack/react-query"
import { getAuthenticatedAxios } from "./use-authenticated-axios"
import { BillingSummaryParams } from "src/internal-types"
import { useCurrentWorkspaceId } from "src/core/hooks/use-current-workspace-id"

export const useBillingSummary = (params?: BillingSummaryParams) => {
  const isAuthenticated = useIsAuthenticated()
  const workspaceIdRaw = useCurrentWorkspaceId()
  const workspace_id =
    typeof workspaceIdRaw === "string" ? workspaceIdRaw : undefined

  return useQuery({
    queryKey: ["billing_summary", workspace_id, params?.checkout_session_id],
    queryFn: async () => {
      const axios = getAuthenticatedAxios(workspace_id)
      try {
        const response = await axios.get(
          `/internal/customer/get_billing_summary`,
          { params }
        )
        // Backend may briefly return an empty body during dev/rollouts; treat
        // a missing billing_summary as "no data yet" rather than crashing the
        // entire SeamContainer subtree on a destructure error.
        return response?.data?.billing_summary ?? null
      } catch (error) {
        console.error("Error getting user billing summary: ", error)
        throw error
      }
    },
    enabled: isAuthenticated && Boolean(workspace_id),
    retry: 1,
  })
}
